import React from "react";
import "./SparkButton.css";


function SparkButton({

  spark,
  setSpark,

  x = 100,
  y = 100,

  width = 80,
  height = 35

}) {


  const handleSpark = () => {

    // Only turn ON
    if (!spark) {

      setSpark(true);

    }

    // Do nothing if already ON
    // Flame logic will handle OFF
  };



return (

<button

className={`spark-button ${spark ? "ON":"OFF"}`}

onClick={handleSpark}

style={{

position:"absolute",

left:x,
top:y,

width,
height,

}}

>

⚡ {spark ? "SPARK ON":"SPARK"}

</button>


);


}


export default SparkButton;